import { createAction } from '@ngrx/store';

export const tickAction = createAction('[Clock] Tick', (time: string) => {
  return { time };
});
